.container {
  width: fit-content;
  overflow: hidden;
  border-radius: 0.4rem;
  overflow: hidden;

  &:hover {
    cursor: pointer;
  }

  &[data-icon-only='true'] {
    min-width: 0;
    max-width: 2.4rem;
    max-height: 2.4rem;
    min-height: 2.4rem;
    border: none;
  }

  &[data-disabled='true'] {
    cursor: default;
    pointer-events: none;
  }
}

.trigger {
  display: flex;
  min-width: 0;
  box-sizing: border-box;
  align-items: center;
  border-radius: 0.4rem;

  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &[data-icon-only='true'] {
    padding: 0;
    min-width: 2.4rem;
    height: 2.4rem;
    align-items: center;
    justify-content: center;
    border: none;
  }

  &[data-variant='minimal'] {
    height: 2.4rem;
    padding: 0.6rem 0.8rem;
    background: var(--color-surfaces-bg-elevation-2);
    border-color: transparent;

    &[data-placeholder='true'] {
      border: 0.1rem dashed var(--color-texts-low-contrast);
    }
  }

  &[data-placeholder='true'] {
    padding: 0.6rem 0.8rem;
    flex-direction: row;
    color: var(--color-texts-low-contrast);
    background: transparent;
  }

  &:hover,
  &:focus-visible {
    border: none;
    cursor: pointer;

    &[data-variant='minimal'] {
      border-color: transparent;

      &[data-placeholder='true'] {
        border: 0.1rem dashed var(--color-texts-middle-contrast);
      }
    }

    &[data-placeholder='true'] {
      background: var(--color-surfaces-bg-elevation-3);
    }

    &[data-disabled='true'] {
      cursor: default;
      pointer-events: none;
      border-color: var(--color-surfaces-bg-elevation-2);
      background: transparent;

      & > span,
      & > svg {
        color: var(--color-texts-low-contrast);
      }
    }
  }

  &[data-disabled='true'] {
    cursor: default;
    pointer-events: none;

    > div > span {
      color: var(--color-grayscale-shuttle);
    }

    &:hover,
    &:focus-visible {
      background-color: transparent !important;
    }
  }
}

.custom-avatar {
  display: flex;
  min-width: 2.4rem;
  min-height: 2.4rem;
  max-width: 2.4rem;
  max-height: 2.4rem;
  justify-content: center;
  align-items: center;
  border-radius: 0.4rem;
  padding: 0.4rem;
  color: var(--color-texts-medium-contrast);

  > span > img,
  > span > span {
    border: 1px solid transparent;
    border-radius: 0.4rem;

    &:hover,
    &:focus-visible {
      border: 1px var(--color-grayscale-ghost) solid;
      border-radius: 0.4rem;
    }
  }

  > span > img {
    background: transparent;
  }

  > span > span {
    background: var(--color-grayscale-trout);
  }
}

.placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.4rem;
  width: 2.4rem;
  min-width: 2.4rem;
  border-radius: var(--border-radius-small);
  border: 1px var(--color-grayscale-light-slate) dashed;
  color: var(--color-grayscale-light-slate);
  background-color: transparent;

  &[data-is-not-option='true'] {
    &:hover {
      cursor: pointer;
      color: var(--color-texts-high-contrast);
      border-color: var(--color-texts-high-contrast);
    }
  }

  &[data-for-modal='true'] {
    min-width: 0;
    width: unset;
    height: unset;
    border: unset;

    &:hover {
      color: var(--color-texts-low-contrast);
    }
  }
}
